// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* eslint-disable max-len */
/* ─── Minimal custom styles that can't be done with Tailwind alone ─── */
.dtb-select[data-v-49fba7e2] {
  box-sizing: border-box;
  display: block;
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-stroke) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 13px;
  --tw-text-opacity: 1;
  color: rgb(57 56 76 / var(--tw-text-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: all;
  transition-duration: 150ms;
  -webkit-appearance: auto;
     -moz-appearance: auto;
          appearance: auto;
}
.dtb-select[data-v-49fba7e2]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(var(--color-secondary) / 0.18);
}
.dtb-input[data-v-49fba7e2] {
  box-sizing: border-box;
  display: block;
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-stroke) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 13px;
  --tw-text-opacity: 1;
  color: rgb(57 56 76 / var(--tw-text-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: all;
  transition-duration: 150ms;
}
.dtb-input[data-v-49fba7e2]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(var(--color-secondary) / 0.18);
}
.dtb-field-label[data-v-49fba7e2] {
  margin-bottom: 3px;
  display: block;
  font-size: 12px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(139 139 151 / var(--tw-text-opacity));
}
.dtb-error[data-v-49fba7e2] {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(var(--color-alert) / var(--tw-text-opacity));
}
.dtb-hint[data-v-49fba7e2] {
  margin-top: 4px;
  font-size: 11px;
  --tw-text-opacity: 1;
  color: rgb(139 139 151 / var(--tw-text-opacity));
}
.dtb-icon-btn[data-v-49fba7e2] {
  display: inline-flex;
  height: 28px;
  width: 28px;
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border-style: none;
  background-color: transparent;
  padding: 0;
  --tw-text-opacity: 1;
  color: rgb(139 139 151 / var(--tw-text-opacity));
  transition-property: all;
  transition-duration: 150ms;
}
.dtb-icon-btn svg[data-v-49fba7e2] {
  height: 15px;
  width: 15px;
}
.dtb-icon-btn[data-v-49fba7e2]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-dark) / var(--tw-bg-opacity));
}
.dtb-icon-btn[data-v-49fba7e2]:disabled {
  cursor: not-allowed;
  opacity: 0.30;
}
.dtb-btn-sm[data-v-49fba7e2] {
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  gap: 4px;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-stroke) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-dark) / var(--tw-bg-opacity));
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 11px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(139 139 151 / var(--tw-text-opacity));
  transition-property: background-color, border-color, color, fill, stroke;
  transition-duration: 150ms;
}
.dtb-btn-sm[data-v-49fba7e2]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-off-white) / var(--tw-bg-opacity));
}

/* Transition */
.dtb-step-anim-enter-active[data-v-49fba7e2],
.dtb-step-anim-leave-active[data-v-49fba7e2] {
  transition: all 0.25s ease;
}
.dtb-step-anim-enter[data-v-49fba7e2],
.dtb-step-anim-leave-to[data-v-49fba7e2] {
  opacity: 0;
  transform: translateY(-8px);
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
